import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';

export interface HistoryChipProps {
  /** Truncated display label shown inside the chip. */
  label: string;
  /** Already-localized tooltip text (e.g. tString('atlasFields.fillFromHistory', value)). */
  tooltip: string;
  /** Invoked when the chip is clicked. The caller closes over the value to apply. */
  onApply: () => void;
}

/**
 * Reusable "fill from history" chip. Single owner of the history-suggestion UI,
 * rendered as a sibling of MLPredictionCell in the ATLAS form so it is visible
 * regardless of ML prediction state.
 */
const HistoryChip: React.FC<HistoryChipProps> = ({ label, tooltip, onApply }) => (
  <Tooltip title={tooltip} placement="top" arrow>
    <Chip
      icon={<HistoryIcon />}
      label={label}
      size="small"
      aria-label={tooltip}
      onClick={onApply}
      sx={{
        height: 20,
        fontSize: '0.65rem',
        fontWeight: 600,
        cursor: 'pointer',
        bgcolor: '#63577e70',
        color: '#fff',
        border: 'none',
        '& .MuiChip-label': { px: 0.75 },
        '& .MuiChip-icon': { fontSize: '0.75rem !important', ml: '3px', color: '#fff' },
        '&:hover': { bgcolor: 'secondary.main' },
      }}
    />
  </Tooltip>
);

export default HistoryChip;
